import { render } from "./GalleryImage.vue?vue&type=template&id=6a76bc4e&scoped=true"
import script from "./GalleryImage.vue?vue&type=script&lang=js"
export * from "./GalleryImage.vue?vue&type=script&lang=js"

import "./GalleryImage.vue?vue&type=style&index=0&id=6a76bc4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a76bc4e"

export default script